<template>
  <div>
    <a-modal
      title="个人信息编辑"
      :visible="visible"
      @ok="handleSubmit"
      :confirmLoading="confirmLoading"
      @cancel="showModal(false)"
      :maskClosable="false"
      :width="width"
    >
      <div class="public-modal">
        <a-form :form="form" :selfUpdate="true">
          <a-row :gutter="8">
            <a-col :span="11">
              <a-form-item label="人员姓名" :label-col="labelCol" :wrapper-col="wrapperCol" hasFeedback>
                <a-input
                  autocomplete="off"
                  v-decorator="[
                    'userName',
                    {
                      validateTrigger: ['blur'],
                      rules: [
                        { required: true, message: '请输入人员姓名!' },
                        {
                          pattern: /^[^\s]*$/,
                          message: '人员姓名不能包含空格'
                        },
                        {
                          pattern: /^[\u4e00-\u9fa5_a-zA-Z0-9]+$/,
                          message: '人员姓名只允许是中英文数字类型'
                        },
                        {
                          max: 50,
                          message: '最多可输入50个字符'
                        }
                      ]
                    }
                  ]"
                />
              </a-form-item>
            </a-col>

            <a-col :span="11">
              <a-form-item label="职工编号" :label-col="labelCol" :wrapper-col="wrapperCol" hasFeedback>
                <a-input
                  disabled
                  v-decorator="[
                    'userNumber',
                    { validateTrigger: ['blur'], rules: [{ required: true, message: '请输入职工编号!' }] }
                  ]"
                />
              </a-form-item>
            </a-col>
            <a-col :span="11">
              <a-form-item label="籍贯" :label-col="labelCol" :wrapper-col="wrapperCol" hasFeedback>
                <a-cascader
                  :options="areaList"
                  v-model="defaultBirthplace"
                  :showSearch="{ filter }"
                  @change="onChange"
                  placeholder="请选择籍贯"
                  changeOnSelect
                />
              </a-form-item>
            </a-col>

            <a-col :span="11">
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="学历" hasFeedback>
                <a-select placeholder="请选择学历" v-decorator="['education']">
                  <a-select-option v-for="(item, index) in educationList" :value="item.code" :key="index">
                    {{ item.name }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>

            <a-col :span="11">
              <a-form-item label="职称" :label-col="labelCol" :wrapper-col="wrapperCol" hasFeedback>
                <a-select
                  showSearch
                  optionFilterProp="children"
                  :filterOption="filterOption"
                  placeholder="请选择职称"
                  v-decorator="['rank']"
                >
                  <a-select-option v-for="(item, index) in titleList" :value="item.code" :key="index">
                    {{ item.name }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>

            <a-col :span="11">
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="政治面貌">
                <a-select
                  showSearch
                  optionFilterProp="children"
                  :filterOption="filterOption"
                  placeholder="请选择政治面貌"
                  v-decorator="['politicalStatus']"
                >
                  <a-select-option v-for="(item, index) in politicalList" :value="item.code" :key="index">
                    {{ item.name }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>

            <a-col :span="11">
              <a-form-item label="民族" :label-col="labelCol" :wrapper-col="wrapperCol" hasFeedback>
                <a-select
                  showSearch
                  optionFilterProp="children"
                  :filterOption="filterOption"
                  placeholder="请选择民族"
                  v-decorator="['nation']"
                >
                  <a-select-option v-for="(item, index) in nationList" :value="item.id" :key="index">
                    {{ item.nation }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>

            <a-col :span="11">
              <a-form-item label="婚姻状况" :label-col="labelCol" :wrapper-col="wrapperCol" hasFeedback>
                <a-select
                  showSearch
                  optionFilterProp="children"
                  :filterOption="filterOption"
                  placeholder="请选择婚姻状况"
                  v-decorator="['maritalStatus']"
                >
                  <a-select-option :value="0">未婚</a-select-option>
                  <a-select-option :value="1">已婚</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>

            <a-col :span="11">
              <a-form-item label="出生日期" :label-col="labelCol" :wrapper-col="wrapperCol" hasFeedback>
                <a-date-picker
                  style="width:228px"
                  :showToday="false"
                  placeholder="请选择出生日期"
                  format="YYYY-MM-DD"
                  v-decorator="['brithday']"
                />
              </a-form-item>
            </a-col>

            <a-col :span="11">
              <a-form-item label="入职日期" :label-col="labelCol" :wrapper-col="wrapperCol" hasFeedback>
                <a-date-picker
                  style="width:228px"
                  :showToday="false"
                  placeholder="请选择入职日期"
                  format="YYYY-MM-DD"
                  v-decorator="['entryDate']"
                />
              </a-form-item>
            </a-col>

            <a-col :span="11">
              <a-form-item label="家庭住址" :label-col="labelCol" :wrapper-col="wrapperCol" hasFeedback>
                <a-input
                  autocomplete="off"
                  placeholder="请输入家庭地址"
                  v-decorator="[
                    'address',
                    {
                      rules: [
                        {
                          pattern: /^[^\s]*$/,
                          message: '家庭住址不能包含空格！'
                        },
                        {
                          max: 50,
                          message: '最多可输入50个字'
                        }
                      ]
                    }
                  ]"
                />
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="8" v-for="(k, index) in form.getFieldValue('keys')" :key="k">
            <p v-if="index === 0" class="row-title">紧急联系人</p>
            <a-col :span="11">
              <a-form-item label="姓名" :label-col="labelCol" :wrapper-col="wrapperCol" hasFeedback>
                <a-input
                  placeholder="请输入紧急联系人姓名"
                  showSearch
                  optionFilterProp="children"
                  :filterOption="filterOption"
                  v-decorator="[
                    `userContactList[${k}].name`,
                    {
                      rules: [
                        {
                          pattern: /^[^\s]*$/,
                          message: '紧急联系人姓名不能包含空格！'
                        },
                        {
                          max: 20,
                          message: '最多可输入20个字'
                        }
                      ]
                    }
                  ]"
                />
              </a-form-item>
            </a-col>

            <a-col :span="11">
              <a-form-item label="电话" :label-col="labelCol" :wrapper-col="wrapperCol" hasFeedback>
                <a-input
                  autocomplete="off"
                  placeholder="请输入紧急联系人电话"
                  v-decorator="[
                    `userContactList[${k}].tel`,
                    {
                      validateTrigger: ['blur'],
                      rules: [
                        {
                          pattern: /^[0-9]+$/,
                          message: '紧急联系人电话只允许数字'
                        },
                        {
                          max: 11,
                          message: '最多可输入11个字符'
                        }
                      ]
                    }
                  ]"
                />
              </a-form-item>
            </a-col>

            <a-col :span="2">
              <a-button
                shape="circle"
                icon="close"
                @click="() => remove(k)"
                :disabled="form.getFieldValue('keys').length === 1"
              ></a-button>
            </a-col>
          </a-row>
          <a-button type="dashed" @click="add" block class="add-btn"> <a-icon type="plus" />添加 </a-button>
        </a-form>
      </div>
    </a-modal>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import moment from 'moment'

export default {
  name: 'PersonalModal',
  beforeCreate () {
    this.form = this.$form.createForm(this, { name: 'personalInfo_form' })
  },
  data () {
    return {
      visible: false,
      confirmLoading: false,
      userId: null,
      width: 800,
      infoLoading: false, // 编辑窗口，获取详情loading
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      model: {},
      educationList: [],
      defaultBirthplace: [],
      areaList: [],
      nationList: [],
      titleList: [],
      politicalList: [],
      contactId: null
    }
  },
  computed: {
    ...mapGetters(['userInfo'])
  },
  mounted () {
    this.initDictData()
  },
  methods: {
    ...mapActions([
      'handleGetPersonalInfo',
      'handleUpdatePersonalInfo',
      'getAreaList',
      'getDictInfoByCode',
      // 'handleGetAreaList',
      // 'handleGetNationList'
    ]),
    showModal (flag) {
      this.formClear()
      this.visible = flag
      if (flag) {
        this.getModelInfo()
      }
    },
    handleSubmit (e) {
      this.confirmLoading = true

      this.form.validateFieldsAndScroll((err, value) => {
        if (!err) {
          const params = { ...value }
          params.id = this.userInfo.id
          params.brithday = moment(params.brithday).format('YYYY-MM-DD')
          params.entryDate = moment(params.entryDate).format('YYYY-MM-DD')
          params.province = this.defaultBirthplace[0] === undefined ? '' : this.defaultBirthplace[0]
          params.city = this.defaultBirthplace[1] === undefined ? '' : this.defaultBirthplace[1]
          params.district = this.defaultBirthplace[2] === undefined ? '' : this.defaultBirthplace[2]

          console.log('params', params)

          this.handleUpdatePersonalInfo(params).then(res => {
            console.log('编辑结果', res)
            if (res.status === 0) {
              this.$message.success(res.info.message)
              this.visible = false
            } else {
              this.$message.error(res.info.message)
            }
          })
        }
      })
      this.confirmLoading = false
    },
    initDictData () {
      // 获取学历列表
      this.getDictInfoByCode('EDUCATION').then(res => {
        this.educationList = res
      })

      // // 获取地区数据
      // this.handleGetAreaList().then(res => {
      //   // console.log('地区数据', res)
      //   this.areaList = res
      // })

      // // 获取民族数据
      // this.handleGetNationList().then(res => {
      //   this.nationList = res.data
      // })

      // 获取职称数据
      this.getDictInfoByCode('JOB_TITLE').then(res => {
        this.titleList = res
      })

      // 获取政治面貌
      // 政治面貌列表
      this.getDictInfoByCode('POLITICAL').then(res => {
        this.politicalList = res
      })
    },
    // 获取用户信息
    getModelInfo () {
      this.handleGetPersonalInfo().then(res => {
        const data = res
        console.log('用户信息', data)

        this.defaultBirthplace = [data.province, data.city, data.district]
        console.log('defaultBirthplace', this.defaultBirthplace)

        this.form.getFieldDecorator('keys', {
          initialValue: this.numberToArray(data.userContactList.length),
          preserve: true
        })

        if (data.userContactList.length === 0) {
          this.contactId = data.userContactList.length + 1
        } else {
          this.contactId = data.userContactList.length
        }

        console.log('this.contactId', this.contactId)

        this.$nextTick(() => {
          this.form.setFieldsValue({
            userName: data.userName,
            userNumber: data.userNumber,
            education: data.education,
            brithday: data.brithday ? moment(data.brithday).utc(8) : undefined,
            entryDate: data.entryDate ? moment(data.entryDate).utc(8) : undefined,
            politicalStatus: data.politicalStatus,
            rank: data.rank,
            nation: data.nation,
            maritalStatus: data.maritalStatus,
            address: data.address,
            userContactList: data.userContactList.map(item => {
              return {
                name: item.name,
                tel: item.tel
              }
            })
          })
        })
      })
    },
    onChange (value, selectedOptions) {
      console.log(value, selectedOptions)
      this.defaultBirthplace = value
    },
    filter (inputValue, path) {
      return path.some(option => option.label.toLowerCase().indexOf(inputValue.toLowerCase()) > -1)
    },
    // 清空表单
    formClear () {
      this.form.resetFields()
    },
    cancel () {
      this.formClear()
    },
    add () {
      const { form } = this
      const keys = form.getFieldValue('keys')
      const nextKeys = keys.concat(this.contactId++)
      form.setFieldsValue({
        keys: nextKeys
      })
    },
    remove (k) {
      const { form } = this
      const keys = form.getFieldValue('keys')
      if (keys.length === 1) {
        return
      }
      form.setFieldsValue({
        keys: keys.filter(key => key !== k)
      })
    },
    numberToArray (num) {
      if (num === 0) {
        return [0]
      } else {
        const arr = []
        for (let i = 0; i < num; i++) {
          arr.push(i)
        }
        return arr
      }
    },
    filterOption (input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    }
  }
}
</script>
